import { render, staticRenderFns } from "./UiKv.vue?vue&type=template&id=e0e48e04"
import script from "./UiKv.vue?vue&type=script&lang=js"
export * from "./UiKv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports